import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  DefaultOrganizationsState,
  OrganizationsState,
} from "../state/stateItems";
import { TOrganizationInvitationItem, TOrganizationItem } from "@/data/types";
import {
  getAllOrganizationsAsync,
  getCurrentOrganizationAsync,
  getOrganizationByIdAsync,
  getOrganizationInvitationsAsync,
} from "../actions";

const handleGetAllOrganizationsAsync = (
  state: OrganizationsState,
  action: PayloadAction<{ items: TOrganizationItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.items = items;
};

const handleGetOrganizationByIdAsync = (
  state: OrganizationsState,
  action: PayloadAction<TOrganizationItem>
) => {
  if (!action?.payload) {
    return state;
  }

  const organization = action.payload;

  state.currentOrganization = organization;
};

const handleGetOrganizationInvitationsAsync = (
  state: OrganizationsState,
  action: PayloadAction<{ items: TOrganizationInvitationItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.invitations = items;
};

const reducerBuilder = (
  builder: ActionReducerMapBuilder<OrganizationsState>
) => {
  builder.addCase(
    getAllOrganizationsAsync.fulfilled.type,
    handleGetAllOrganizationsAsync
  );
  builder.addCase(
    getCurrentOrganizationAsync.fulfilled.type,
    handleGetOrganizationByIdAsync
  );
  builder.addCase(
    getOrganizationInvitationsAsync.fulfilled.type,
    handleGetOrganizationInvitationsAsync
  );
};

export default createReducer(DefaultOrganizationsState, reducerBuilder);
